var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShieldSlash = function SvgIconShieldSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.468 1.51a1 1 0 0 1 1.413.068l17.719 19.5a1 1 0 0 1-1.48 1.345l-2.561-2.818a13.9 13.9 0 0 1-4.998 3.015c-.363.13-.76.13-1.123 0-1.418-.472-8.688-3.305-8.688-11.867V5.25a1.75 1.75 0 0 1 .582-1.303L2.4 2.922a1 1 0 0 1 .067-1.412M4.75 5.508l11.463 12.616c-1.655 1.591-3.518 2.337-4.213 2.575-1.43-.49-7.25-2.924-7.25-9.946z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.256 3.5a1 1 0 1 0 0 2h8.994v5.261c.01 1.25-.196 2.494-.61 3.674a1 1 0 1 0 1.888.661 12.8 12.8 0 0 0 .722-4.347V5.25A1.75 1.75 0 0 0 19.5 3.5z"
  }))));
};
export default SvgIconShieldSlash;